
const React = require('react');
const Link = require('react-router-dom').Link;
const AjaxFunctions = require('../ajaxFunctions');
const Avatar = require('./commonControls.jsx.js').userAvatar;
const SharedConstants = require('../../../../shared/sharedConstants');
const Redirect = require('react-router-dom').Redirect;
const LeftBarScreen = require('../constants.js').LeftBarScreen;
const ReduxStore = require('../redux/reduxStore.jsx.js');
const TextInputModal = require('./textInputModal.jsx.js').TextInputModal;
const Utils = require('../utils');
import Button from "@material-ui/core/Button";
import Toastr from "toastr";
import {Comment} from './comment.jsx.js'
import { HoverModal } from "./hoverModal.js";
import { UserAvatarV2 } from "./commonControls.jsx.js";


let tooltipTitle = (title) => {
   return (
      <React.Fragment>
         <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
            {title}
         </div>
      </React.Fragment>
   )
};

function RemoveButton(props){
   if(!props.removeCardFromPortfolio) return (<div />);
   return(
      <div className='card-row-button-container'>
         <i className="fas fa-times text-danger" onClick={() => props.removeCardFromPortfolio(props.card)} />
      </div>
   )
}

function UpVoteButton(props){
   return(
      <Tooltip title={tooltipTitle(`This ${String.fromCharCode(181)}Pub is relevant`)}>
         <IconButton className={'btn-top-bar-icon'} aria-label={`This microPub is relevant`} onClick={() => props.voteFunction()}>
            <FontAwesomeIcon icon={['fas',"arrow-up"]} size={'1x'} />
         </IconButton>
      </Tooltip>
   )
}

function DownVoteButton(props){
   return(
      <Tooltip title={tooltipTitle(`This ${String.fromCharCode(181)}Pub is not relevant`)}>
         <IconButton className={'btn-top-bar-icon'} aria-label={`This microPub is not relevant`} onClick={() => props.voteFunction()}>
            <FontAwesomeIcon className={'btn-downvote'} icon={['fas',"arrow-down"]} size={'1x'} />
         </IconButton>
      </Tooltip>
   )
}

function UserDiv(props){
   if(props.card.cardType !== SharedConstants.CardType.Synthesis){
      return(
         <div className="post-header-text">
           <HoverModal 
               linkTo={`/users/profile?idUser=${props.card.creator.id}`}
               textTitle={`${props.card.creator.firstName} ${props.card.creator.lastName}`}
               titleStyle={{fontWeight:'bolder', fontSize:16, color:'#007bff'}}
               avatar={props.card.creator.hasAvatar ? `${window.globals.USER_UPLOADS_BASE_URL}/${props.card.creator.id}/Avatar.png` : null}
               chipText={`Level ${Utils.calculateUserLevel(props.card.creator.points)} (${props.card.creator.points})`}
               hoverTitle={`${props.card.creator.firstName} ${props.card.creator.lastName}`}
               hoverSubtitle={`${props.card.creator.affiliation || ''}`}
               hoverText={props.card.creator.bio || ''}
               hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
               hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
            <div className="post-time">{new Date(props.card.creationTime).toLocaleDateString()}</div>

         </div>
      )
   }
   return(<div />);
}



class IncubatorCardRowBase extends React.Component{
   constructor(props){
      super(props);
      this.state = {
         showComments: false,
         showAddToIncubatorModal: false,
         idIncubatorToAddCardTo: 0,
         nameIncubatorToAddCardTo: '',
         
      }
   }

   async addCardToIncubator(){
      Toastr.options.positionClass = 'toast-bottom-full-width';
      try {
         let result = await AjaxFunctions.addCardToEndOfPortfolio(
            this.props.idPortfolio,
            this.props.card.id,
            this.props.card.cardType,
         );
         let pointAwardResult = result.pointAwardResult?result.pointAwardResult:"Your Incubator"
         let toastString = pointAwardResult+' is now in review. <a href="/incubator?idIncubator='
            + this.props.idPortfolio
            + '"><u>"'
            + this.props.portfolioName
            + '"</u></a>';
         Toastr.success(toastString);

         this.props.getUpdatedPortfolioData();
      }
      catch(err){
         Toastr.error(err);
      }
   }

   render() {
      let submitterLink = () => {
         if(this.props.card.idSubmitter && this.props.card.submitterFirstName && this.props.card.submitterLastName){
            return(
               <div className={'submitter-link'}>
                  <Link to={'/users/profile?idUser=' + this.props.card.idSubmitter}>
                     {`${this.props.card.submitterFirstName} ${this.props.card.submitterLastName} `}
                  </Link>
                  Added:
               </div>
            )
         }
      };
      let mainBody = () => {
         return this.props.cardLink ? <Link to={this.props.cardLink} className='dashboard-row-body-content' onClick={this.props.linkFunction}>
            {this.props.prefixText}
            {this.props.title}
         </Link> :
            <div>
               {this.props.prefixText}
               {this.props.title}
            </div>
      }     
      return(
         <div className={this.props.fullClassName} id={this.props.id}>
            {submitterLink()}
            <div className={`activity-list-item ${this.props.showAddButton?"":this.props.itemClass}`}>
               {this.props.showAddButton &&
                  <Button
                     className={this.props.itemClass + '-add-button'}
                     style={{ color:'white', marginRight: '1em' }}
                     onClick={() => {
                        if(this.props.addCardFunction){
                           this.props.addCardFunction(this.props.card.id, this.props.card.cardType);
                        }else{
                           this.addCardToIncubator()
                        }
                        }}
                  >
                     Add
                  </Button>
               }
               <div style={{marginRight:'10px'}}>
               <UserAvatarV2 size='small' userData={this.props.card.creator} />
               </div>
               <div className="post-main">
                  <div className="post-header">
                     <UserDiv
                        card={this.props.card}
                     />
                  </div>
                  <div className="post-body">
                     {mainBody()}
                     <br/>
                     {(this.props.card.comments.length > 0) && (this.state.showComments ? <Button className="material-button" style={{ paddingLeft: 0 }} onClick={() => this.setState({ showComments: !this.state.showComments })}>
                        {`Comments: ${this.props.card.comments.length} ▲`}
                     </Button> : <Button className="material-button" style={{ paddingLeft: 0 }} onClick={() => this.setState({ showComments: !this.state.showComments })}>
                           {`Comments: ${this.props.card.comments.length} ▼`}
                        </Button>)}
                     {this.state.showComments && this.props.card.comments.map((curCard, i) => {
                        let commentTime = new Date();
                        commentTime.setMinutes(new Date().getMinutes() - curCard.minutesSinceCreation);
                        return <Comment key={i} commentTime={commentTime} user={curCard.user} text={curCard.text} showDelete={false} showSideBorder={true}/>
                     })}
                  </div>
               </div>
            </div>
         </div>
      )
   }
}


class EvidenceIncubatorCardRow extends React.Component{
   render() {
      let cardLink = null;
      if(!this.props.disableCardLink){
         cardLink = this.props.linkBase +
            (this.props.linkBase.includes('?') ? '&' : '?') +
            'cardType=' + SharedConstants.CardType.Evidence +
            '&idCard=' + this.props.card.id +
            '&cModalOpen=1'
      }
      return(
         <IncubatorCardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='evidence-item'
            cardLink={cardLink}
            id={this.props.card.index ? 'e' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class ConjectureIncubatorCardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         isExpanded: false,
      }
   }

   render() {
      let linkedCards = () => {};
      if(this.state.isExpanded) {
         linkedCards = () => {
            return (
               <div>
                  <i className="fas fa-chevron-up btn-expanded-toggle"
                     title='Collapse linked evidence information'
                     onClick={() => this.setState({isExpanded: false})}
                  />
                  <IncubatorCardRow
                     cardType={SharedConstants.CardType.Evidence}
                     card={this.props.card.evidenceCard1}
                     linkFunction={(card) => this.props.linkFunction(card)}
                     showLinkBtn={false}
                     showFavoriteBtn={false}
                     linkBase={this.props.linkBase}
                  />
                  <IncubatorCardRow
                     cardType={SharedConstants.CardType.Evidence}
                     card={this.props.card.evidenceCard2}
                     linkFunction={(card) => this.props.linkFunction(card)}
                     showLinkBtn={false}
                     showFavoriteBtn={false}
                     linkBase={this.props.linkBase}
                  />
               </div>
            )
         };
      }
      else{
         linkedCards = () => {
            return (
               <div className='conjecture-row-evidence-container activity-list-item evidence-item'>
                  <div>
                        <span title={this.props.card.evidenceCard1.title}>
                           {Avatar(this.props.card.evidenceCard1.creator)}
                        </span>
                     <span title={this.props.card.evidenceCard2.title}>
                           {Avatar(this.props.card.evidenceCard2.creator)}
                        </span>
                     <i className="fas fa-chevron-down btn-expanded-toggle"
                        title='Show all linked evidence information'
                        onClick={() => this.setState({isExpanded: true})}
                     />
                  </div>
               </div>
            )
         };
      }
      let cardLink = null;
      if(!this.props.disableCardLink){
         cardLink = this.props.linkBase +
            (this.props.linkBase.includes('?') ? '&' : '?') +
            'cardType=' + SharedConstants.CardType.Reasoning +
            '&idCard=' + this.props.card.id +
            '&cModalOpen=1'
      }
      return(
         <IncubatorCardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName + ' conjecture-group'}
            itemClass='conjecture-item'
            cardLink={cardLink}
            id={this.props.card.index ? 'g' + this.props.card.index : ''}
            linkedCards={linkedCards}
         />
      )
   }
}

class NoteIncubatorCardRow extends React.Component{
   render() {
      return(
         <IncubatorCardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='note-item'
            cardLink={``}
            id={this.props.card.index ? 'n' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class SynthesisIncubatorCardRow extends React.Component{
   render() {
      this.props.card.creator = null;
      return(
         <IncubatorCardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='synthesis-item'
            cardLink={''}
            id={this.props.card.index ? 's' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class QuestionIncubatorCardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showAnswerModal: false,
      }
   }

   async modalConfirmFunction(answerText){
      Toastr.options.positionClass = 'toast-bottom-full-width';
      try{
         await AjaxFunctions.submitQuestionAnswer(this.props.card.id, answerText);
         Toastr.success('Answer Submitted.');
         this.props.onQuestionAnswered();
      }
      catch(err){
         Toastr.error(err);
      }
   }

   render() {
      return(
         <div id={this.props.card.index ? 'q' + this.props.card.index : ''}>
            <div className={"activity-list-item question-item"}>
               <RemoveButton
                  card={this.props.card}
                  removeCardFromPortfolio={this.props.removeCardFromPortfolio}
               />
               <div className='card-row-button-container'>
                  <div>
                     {
                        this.props.upVoteFunction && this.props.card.voteType !== SharedConstants.VoteType.UpVote &&
                        <UpVoteButton voteFunction={() => this.props.upVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
                  <div>
                     {
                        this.props.downVoteFunction && this.props.card.voteType === SharedConstants.VoteType.UpVote &&
                        <DownVoteButton voteFunction={() => this.props.downVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
               </div>
               <div className="post-main">
                  <div className="post-header">
                     <div className="post-header-text">
                        <div className="post-time">{new Date(this.props.card.creationTime).toLocaleDateString()}</div>
                     </div>
                  </div>
                  <div className="post-body">
                     {this.props.title}
                  </div>
                  <div className={'post-body question-card-answer' + (!this.props.card.answer ? ' hidden': '' )}>
                     {this.props.card.answer}
                  </div>
                  {
                     this.props.showAnswerButton &&
                     <Button
                        variant="contained"
                        onClick={() => this.setState({showAnswerModal: true})}
                        className={'btnStartAnswer'}
                        color="primary">
                        Answer
                     </Button>
                  }
                  <TextInputModal
                     show={this.state.showAnswerModal}
                     contentText={this.props.title}
                     confirmText={'Submit Answer'}
                     label={'Your Answer'}
                     confirmFunction={(answerText) => this.modalConfirmFunction(answerText)}
                     closeFunction={() => this.setState({showAnswerModal: false})}
                  />
               </div>
            </div>
         </div>
      )
   }
}

export class IncubatorCardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         redirectToEvidenceCreation: false,
      }
   }

   editCard(cardData){
      let tagString = '';
      for(let tag of cardData.tags){
         tagString += tag + ' ';
      }

      let toSaveState = {
         source: cardData.source,
         enteredText: cardData.title,
         selectedTopics: cardData.topics,
         tags: tagString,
         citation: cardData.citation,
         sourceDate: cardData.sourceDate,
         tour: null,
         id: cardData.id,
      };

      ReduxStore.store.dispatch(ReduxStore.EvidenceCardFunctions.setRevisingCard(toSaveState));
      this.setState({redirectToEvidenceCreation: true});
   }

   render() {
      if(this.state.redirectToEvidenceCreation){
         return (<Redirect to={'/listView?isRevision=true&leftBarCurScreen=' + LeftBarScreen.CreateCard} />);
      }

      let isApproved = this.props.card.isApproved || this.props.allApproved;

      let prefixText = '';
      if(this.props.card.needsRevision) prefixText = '(Needs Revision) ';
      else if(!isApproved) prefixText = '(In Review) ';

      let title = this.props.card.title;
      if(this.props.titleCharacterLimit){
         title = title.substr(0,this.props.titleCharacterLimit) + ' (click to read more)';
      }

      let baseClassName = '';
      if(!isApproved){
         baseClassName += ' in-review';
      }
      if(this.props.card.needsRevision){
         baseClassName += ' needs-revision';
      }

      let rowProps = {
         card: this.props.card,
         baseClassName,
         upVoteFunction: this.props.upVoteFunction,
         downVoteFunction: this.props.downVoteFunction,
         removeCardFromPortfolio: this.props.removeCardFromPortfolio,
         addToCreation: (card) => this.props.addToCreation(card),
         showFavoriteBtn: this.props.showFavoriteBtn,
         portfolios: this.props.portfolios,
         incubators: this.props.incubators,
         isApproved,
         editCard: (card) => this.editCard(card),
         linkFunction: this.props.linkFunction,
         linkBase: this.props.linkBase,
         prefixText,
         title,
         showAnswerButton: this.props.showAnswerButton,
         onQuestionAnswered: () => this.props.onQuestionAnswered(),
         showLinkBtn: this.props.showLinkBtn,
         rowNumber: this.props.rowNumber,
         showAdditionalFunctionsButton: this.props.showAdditionalFunctionsButton,
         disableCardLink: this.props.disableCardLink,
         showAddButton:this.props.showAddButton,
         idPortfolio: this.props.idPortfolio,
         portfolioName: this.props.portfolioName,
         getUpdatedPortfolioData: this.props.getUpdatedPortfolioData,
         addCardFunction: this.props.addCardFunction
      };

      if(this.props.cardType === SharedConstants.CardType.Evidence){
         return(<EvidenceIncubatorCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Reasoning){
         return(<ConjectureIncubatorCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Note){
         return(<NoteIncubatorCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Synthesis){
         return(<SynthesisIncubatorCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Question){
         return(<QuestionIncubatorCardRow {...rowProps}/>);
      }
      return(
         <IncubatorCardRowBase
            {...rowProps}
         />
      )
   }
}

